import React from 'react';
import PropTypes from 'prop-types';
import DetailsCell from './details_cell';
import { componentText } from '../../utils/i18n_utils';

const t = (key, fallback) => componentText(`details_table.${key}`, fallback);

const DetailsTableHeader = ({ holeLabels, startHoleIndex = null }) => {
  const nrHoles = holeLabels.length;
  return (
    <thead>
      <tr className="lbv2__hole-label-row">
        <DetailsCell as="th" className="lbv2__hole-label text sticky">{t('holes', 'Holes')}</DetailsCell>
        {holeLabels.map((label, index) => (
          <React.Fragment key={index}>
            <DetailsCell as="th" className={`lbv2__hole-label${index === startHoleIndex ? ' starting' : ''}`}>{label}</DetailsCell>
            {label === '9' && nrHoles !== (index + 1) && (
              <DetailsCell as="th" className="lbv2__hole-label out">{t('out', 'Out')}</DetailsCell>
            )}
            {label === '18' && (
              <DetailsCell as="th" className="lbv2__hole-label in">{t('in', 'In')}</DetailsCell>
            )}
            {nrHoles === (index + 1) && (
              <DetailsCell as="th" className="lbv2__hole-label total">{t('total_short', 'Tot')}</DetailsCell>
            )}
          </React.Fragment>
        ))}
      </tr>
    </thead>
  );
};

DetailsTableHeader.propTypes = {
  holeLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  startHoleIndex: PropTypes.number,
};

export default DetailsTableHeader;
